import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-21 16:56:34
 * @LastEditTime: 2022-08-15 14:37:51
 * @FilePath: /insurforce-backstage-platform-side/src/views/claim/recordManage/request.js
 */
import request from '@/utils/request';

// 理赔记录
export function claimsList(data) {
  return request.post('admin/audit/claims-list', data);
}

// v2-新理赔记录
export function claimsRecordList(data) {
  return request.post('admin/claims-record/list', data);
}
// 理赔详情
export function claimsDetail(data) {
  return request.post('admin/claims/detail', data).then(res => {
    console.log(res.claimsInfo);
    res.claimsInfo.claimsDocument.map(i2 => {
      i2.documentUrl.map((i, index) => {
        i.status = 'done';
        i.uid = index + 1;
        return i;
      });
      return i2;
    });
    return res;
  });
}
// v2-新理赔记录
export function auditSchedule(data) {
  return request.post('admin/audit-record/schedule', data);
}
// v2-新审核进度
export function auditDetail(data) {
  return request.post('admin/audit-record/detail', data);
  // .then(res => {
  //   console.log(res.initialNodeInfo.claimsDocument);
  //   if (res.initialNodeInfo.claimsTypeId) {
  //     res.initialNodeInfo.claimsDocument.map(i2 => {
  //       console.log(i2.documentUrl);
  //       let arr = [];
  //       i2.documentUrl.map((i, index) => {
  //         let name = i.substring(i.lastIndexOf('/') + 1, i.lastIndexOf('.'));
  //         let format = i.substring(i.lastIndexOf('.')).toLowerCase();
  //         let obj = {
  //           status: 'done',
  //           uid: index + 1,
  //           url: i,
  //           format: format.slice(1),
  //           name: name + format
  //         };
  //         console.log(obj);
  //         arr.push(obj);
  //       });
  //       i2.documentUrl = arr;
  //       return i2;
  //     });
  //   }
  //   return res;
  // });
}
export function policyResource(data) {
  return request.post('admin/policy/resource', data);
}
export function policyDetail(data) {
  return request.post('admin/policy/detail', data);
}